import React from "react";
import {Box, Flex} from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box backgroundColor="#6B8F71">
      <footer>
        <Flex
          margin="0 auto"
          px={12}
          color="#1D1E18"
          justifyContent="center"
          alignItems="center"
          maxWidth="1024px"
          height={16}
        >
          <p><b>Hallab • © 2022</b></p>
        </Flex>
      </footer>
    </Box>
  );
};
export default Footer;
